import React, {useState} from "react";
import {Box} from "@chakra-ui/react";
import {BrowserRouter as Router, Routes, Route, useLocation, Navigate} from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./pages/About";
import ContactMe from "./pages/ContactMe";
import Projects from "./pages/Projects";
import colors from "./colors";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";


function App() {
    const [isDark, setIsDark] = useState(false);
    const toggleMode = () => setIsDark(!isDark);

    return (
        <Router>
            <AppContent isDark={isDark} toggleMode={toggleMode}/>
        </Router>
    );
}

function AppContent({isDark, toggleMode}) {
    const location = useLocation();

    // const lightBg = `linear-gradient(to bottom, ${colors.brand[50]}, ${colors.green[100]})`;
    const lightBg = `#EEE`;
    const darkBg = `linear-gradient(to bottom, ${colors.darkBg}, ${colors.brand[600]})`;

    const isAboutPage = location.pathname === "/" || location.pathname === "/about";

    return (
        <Box
            minH="100vh"
            bgGradient={isDark ? darkBg : lightBg}
            color={isDark ? "white" : colors.gray[700]}
            transition="all 0.3s ease"
            overflow="hidden" // hide global scroll
        >
            {/* Fixed Header */}
            <Box position="fixed" top="0" left="0" w="100%" zIndex="1000">
                <Header isDark={isDark} toggleMode={toggleMode}/>
            </Box>

            {/* Scrollable Main Content */}
            <Box
                flex="1"
                overflowY={isAboutPage ? "hidden" : "auto"}
                pt="90px"
                pb={{base: "auto", md: "50px"}}
                px={{base: 4, md: 8}}
                maxW="1200px"
                mx="auto"
            >
                <ScrollToTop/>
                <Toaster />
                <Routes>
                    <Route path="/" element={<Navigate to="/about" replace />} />
                    <Route path="/about" element={<About isDark={isDark}/>}/>
                    <Route path="/projects" element={<Projects isDark={isDark}/>}/>
                    <Route path="/contactme" element={<ContactMe isDark={isDark}/>}/>
                </Routes>
            </Box>

            {/* Footer */}
            <Box>
                <Footer isDark={isDark}/>
            </Box>
        </Box>
    );
}

export default App;
